import { Brand } from '@blade/std-lib'

export const AddressTypeId = 'tradebot-tma/Address'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type AddressTypeId = typeof AddressTypeId

export type Address = Brand.Branded<string, AddressTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Address = Brand.nominal<Address>()
